"use client";

import type { CSSProperties, ReactNode } from "react";

import { HourglassMark } from "@/components/HourglassMark";

const TEAL = "#1ca4b1";

type AuthBrandHeaderProps = {
  children: ReactNode;
  /** Extra wrapper style for the logo row */
  style?: CSSProperties;
};

/**
 * Faint orbiting hourglass marks behind the wordmark — fills awkward empty space on auth cards.
 */
export function AuthBrandHeader({ children, style }: AuthBrandHeaderProps) {
  return (
    <div
      style={{
        position: "relative",
        padding: "0.25rem 0.35rem 0",
        marginBottom: "0.25rem",
        ...style,
      }}
    >
      <div
        aria-hidden
        style={{
          position: "absolute",
          left: "-6%",
          right: "-6%",
          top: "-4px",
          bottom: "-6px",
          pointerEvents: "none",
          overflow: "visible",
        }}
      >
        <div className="ed-auth-hg-orbit ed-auth-hg-orbit-a" style={{ left: "2%", top: "18%" }}>
          <HourglassMark size={22} color={TEAL} className="ed-auth-hg-a" style={{ opacity: 0.14 }} />
        </div>
        <div className="ed-auth-hg-orbit ed-auth-hg-orbit-b" style={{ right: "4%", top: "4%" }}>
          <HourglassMark size={30} color={TEAL} className="ed-auth-hg-b" style={{ opacity: 0.16 }} />
        </div>
        <div className="ed-auth-hg-orbit ed-auth-hg-orbit-c" style={{ left: "12%", bottom: "2%" }}>
          <HourglassMark size={18} color={TEAL} className="ed-auth-hg-c" style={{ opacity: 0.12 }} />
        </div>
        <div className="ed-auth-hg-orbit ed-auth-hg-orbit-d" style={{ right: "16%", bottom: "8%" }}>
          <HourglassMark size={24} color={TEAL} className="ed-auth-hg-d" style={{ opacity: 0.13 }} />
        </div>
      </div>
      <div style={{ position: "relative", zIndex: 1 }}>{children}</div>
    </div>
  );
}
